/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Ratio } from './Ratio';
import {
    instanceOfRatio,
    RatioFromJSON,
    RatioFromJSONTyped,
    RatioToJSON,
} from './Ratio';

/**
 * @type AnalysisResultDtoAreaFlatness
 * 
 * @export
 */
export type AnalysisResultDtoAreaFlatness = Ratio;


export function AnalysisResultDtoAreaFlatnessFromJSON(json: any): AnalysisResultDtoAreaFlatness {
    return AnalysisResultDtoAreaFlatnessFromJSONTyped(json, false);
}

export function AnalysisResultDtoAreaFlatnessFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultDtoAreaFlatness {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...RatioFromJSONTyped(json, true) };
    return  RatioFromJSONTyped(json, true);
}

export function AnalysisResultDtoAreaFlatnessToJSON(value?: AnalysisResultDtoAreaFlatness | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfRatio(value)) {
        return RatioToJSON(value as Ratio);
    }

    return {};
}

/**
 * Check if a given object implements the AnalysisResultDtoAreaFlatness interface.
 */
export function instanceOfAnalysisResultDtoAreaFlatness(value: any): value is AnalysisResultDtoAreaFlatness {
    if (instanceOfRatio(value)) return true;
    return false;
}

